import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Hero from "../components/Hero";
import heroImg from "../assests/images/hero.jpg";
import {
    FaHeart,
    FaRegHeart,
    FaMapMarkerAlt,
} from "react-icons/fa";

export default function HotelSearch() {
    const [hotels, setHotels] = useState([]);
    const location = useLocation();
    const searchData = location.state;
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [wishlist, setWishlist] = useState([]);

    /* ================= WISHLIST ================= */

    useEffect(() => {
        const storedWishlist =
            JSON.parse(localStorage.getItem("wishlist")) || [];

        setWishlist(storedWishlist);
    }, []);

    const updateWishlist = (updated) => {
        setWishlist(updated);
        localStorage.setItem(
            "wishlist",
            JSON.stringify(updated)
        );
    };

    const toggleWishlist = (hotel) => {
        const exists = wishlist.find(
            (item) => item.id === hotel.id
        );

        let updated;

        if (exists) {
            updated = wishlist.filter(
                (item) => item.id !== hotel.id
            );
        } else {
            updated = [...wishlist, hotel];
        }

        updateWishlist(updated);
    };

    const isWishlisted = (id) => {
        return wishlist.some(
            (item) => item.id === id
        );
    };

    /* ================= FETCH HOTELS ================= */

    useEffect(() => {
        const fetchHotels = async () => {
            setLoading(true);
            setError(false);

            try {
                const res = await axios.get(
                    "https://dubaihotelrates.com/api/hotels",
                    {
                        params: {
                            destination:
                                searchData?.destination,
                        },
                    }
                );

                setHotels(res.data);
            } catch (err) {
                console.error(err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchHotels();
    }, [searchData]);

    return (
        <div className="bg-slate-50 min-h-screen">

            {/* ================= HERO ================= */}

            <Hero
                heightClass="sm:h-[230px] md:h-[250px] lg:h-[200px]"
                title="Search Results"
                subtitle={
                    searchData?.destination
                        ? `Discover the best hotels in ${searchData.destination}`
                        : "Discover the perfect stay in Dubai"
                }
                backgroundImage={heroImg}
            />

            {/* ================= CONTENT ================= */}

            <section className="relative py-10 sm:py-12 md:py-16">

                {/* Decorative Background */}
                <div className="absolute -top-20 -left-20 w-72 h-72 bg-[#D4A83F]/10 rounded-full blur-3xl pointer-events-none"></div>

                <div className="absolute top-1/2 -right-32 w-80 h-80 bg-[#174B5F]/10 rounded-full blur-3xl pointer-events-none"></div>

                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    {/* ================= HEADER ================= */}

                    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">

                        <div>
                            <span className="
                                inline-flex
                                items-center
                                px-4
                                py-2
                                rounded-full
                                bg-[#F8F5EC]
                                border border-[#D4A83F]/30
                                text-[#174B5F]
                                text-xs
                                sm:text-sm
                                font-semibold
                                mb-3
                            ">
                                Hotel Search
                            </span>

                            <h1 className="
                                text-2xl
                                sm:text-3xl
                                md:text-4xl
                                font-bold
                                text-slate-900
                            ">
                                {searchData?.destination
                                    ? `Hotels in ${searchData.destination}`
                                    : "Search Results"}
                            </h1>

                            <p className="
                                text-slate-500
                                text-sm
                                sm:text-base
                                mt-2
                            ">
                                Find comfortable stays, great locations,
                                and the best available hotel rates.
                            </p>
                        </div>

                        {!loading && !error && hotels.length > 0 && (
                            <div className="
                                inline-flex
                                items-center
                                self-start
                                sm:self-auto
                                px-4
                                py-2
                                rounded-xl
                                bg-white
                                border border-slate-100
                                shadow-sm
                                text-sm
                                text-slate-600
                            ">
                                <span className="font-semibold text-[#174B5F] mr-1">
                                    {hotels.length}
                                </span>
                                hotels found
                            </div>
                        )}

                    </div>


                    {/* ================= LOADING ================= */}

                    {loading ? (
                        <div className="
                            grid
                            grid-cols-1
                            sm:grid-cols-2
                            lg:grid-cols-3
                            gap-6
                            sm:gap-8
                        ">

                            {[1, 2, 3, 4, 5, 6].map(
                                (item) => (
                                    <div
                                        key={item}
                                        className="
                                            bg-white
                                            rounded-[28px]
                                            overflow-hidden
                                            border
                                            border-slate-100
                                            shadow-sm
                                            animate-pulse
                                        "
                                    >
                                        <div className="h-56 bg-slate-200"></div>

                                        <div className="p-6">
                                            <div className="h-5 bg-slate-200 rounded w-3/4"></div>

                                            <div className="h-4 bg-slate-200 rounded w-1/2 mt-3"></div>

                                            <div className="h-4 bg-slate-200 rounded w-full mt-5"></div>

                                            <div className="h-4 bg-slate-200 rounded w-4/5 mt-2"></div>

                                            <div className="h-11 bg-slate-200 rounded-xl mt-6"></div>
                                        </div>
                                    </div>
                                )
                            )}

                        </div>


                    ) : error ? (

                        /* ================= ERROR ================= */

                        <div className="
                            bg-white
                            rounded-[28px]
                            border border-red-100
                            shadow-sm
                            py-20
                            px-6
                            text-center
                        ">

                            <div className="
                                w-16
                                h-16
                                mx-auto
                                rounded-2xl
                                bg-red-50
                                flex
                                items-center
                                justify-center
                                mb-5
                            ">
                                <span className="text-2xl">
                                    !
                                </span>
                            </div>

                            <h3 className="
                                text-xl
                                font-bold
                                text-slate-900
                            ">
                                Unable to load hotels
                            </h3>

                            <p className="
                                text-slate-500
                                text-sm
                                mt-2
                            ">
                                Something went wrong while searching.
                                Please try again.
                            </p>

                            <button
                                onClick={() =>
                                    window.location.reload()
                                }
                                className="
                                    mt-6
                                    px-6
                                    py-3
                                    rounded-xl
                                    bg-gradient-to-r
                                    from-[#002B45]
                                    via-[#174B5F]
                                    to-[#D4A83F]
                                    text-white
                                    font-semibold
                                    text-sm
                                    hover:shadow-lg
                                    hover:-translate-y-0.5
                                    transition-all
                                "
                            >
                                Try Again
                            </button>

                        </div>


                    ) : hotels.length > 0 ? (

                        /* ================= HOTEL GRID ================= */

                        <div className="
                            grid
                            grid-cols-1
                            sm:grid-cols-2
                            lg:grid-cols-3
                            gap-6
                            sm:gap-8
                        ">

                            {hotels.map((hotel) => (

                                <div
                                    key={hotel.id}
                                    onClick={() =>
                                        navigate(
                                            `/hotels/${hotel.slug}`
                                        )
                                    }
                                    className="
                                        group
                                        cursor-pointer
                                        bg-white
                                        rounded-[28px]
                                        overflow-hidden
                                        border border-slate-100
                                        shadow-lg
                                        hover:shadow-[0_20px_50px_rgba(15,23,42,0.14)]
                                        hover:-translate-y-2
                                        transition-all
                                        duration-500
                                    "
                                >

                                    {/* ================= IMAGE ================= */}

                                    <div
                                        className="
                                            relative
                                            h-52
                                            sm:h-56
                                            md:h-60
                                            w-full
                                            overflow-hidden
                                        "
                                        onClick={(e) => {
                                            e.stopPropagation();

                                            navigate(
                                                `/hotels/${hotel.slug}`
                                            );
                                        }}
                                    >

                                        <img
                                            src={`https://uaediscountedhotels.com/uploads/hotels/${hotel.image}`}
                                            alt={hotel.name}
                                            className="
                                                w-full
                                                h-full
                                                object-cover
                                                group-hover:scale-110
                                                transition-transform
                                                duration-700
                                            "
                                        />

                                        {/* Image Overlay */}

                                        <div className="
                                            absolute
                                            inset-0
                                            bg-gradient-to-t
                                            from-black/75
                                            via-black/10
                                            to-transparent
                                        "></div>


                                        {/* ================= LOCATION ================= */}

                                        <div className="
                                            absolute
                                            top-4
                                            left-4
                                            z-20
                                        ">

                                            <span className="
                                                inline-flex
                                                items-center
                                                gap-1.5
                                                bg-white/95
                                                backdrop-blur-md
                                                text-slate-700
                                                px-3
                                                py-1.5
                                                rounded-full
                                                text-xs
                                                font-semibold
                                                shadow-lg
                                            ">

                                                <FaMapMarkerAlt className="text-[#174B5F]" />

                                                {hotel.location ||
                                                    "Dubai, UAE"}

                                            </span>

                                        </div>


                                        {/* ================= WISHLIST ================= */}

                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleWishlist(hotel);
                                            }}
                                            className="
                                                absolute
                                                top-4
                                                right-4
                                                z-20
                                                w-10
                                                h-10
                                                rounded-full
                                                bg-white/95
                                                backdrop-blur-md
                                                shadow-lg
                                                flex
                                                items-center
                                                justify-center
                                                hover:scale-110
                                                hover:bg-red-50
                                                transition-all
                                                duration-300
                                            "
                                            aria-label={
                                                isWishlisted(hotel.id)
                                                    ? "Remove from wishlist"
                                                    : "Add to wishlist"
                                            }
                                        >

                                            {isWishlisted(
                                                hotel.id
                                            ) ? (
                                                <FaHeart className="text-red-500" />
                                            ) : (
                                                <FaRegHeart className="text-slate-500" />
                                            )}

                                        </button>


                                        {/* ================= RATING ================= */}

                                        <div className="
                                            absolute
                                            bottom-4
                                            left-4
                                            z-20
                                            flex
                                            items-center
                                            gap-2
                                        ">

                                            <div className="
                                                flex
                                                items-center
                                                gap-1
                                                bg-white/95
                                                backdrop-blur-md
                                                px-3
                                                py-1.5
                                                rounded-xl
                                                shadow-lg
                                            ">

                                                <span className="text-yellow-500 text-sm">
                                                    ★
                                                </span>

                                                <span className="
                                                    text-slate-900
                                                    text-sm
                                                    font-bold
                                                ">
                                                    {hotel.rating ||
                                                        "4.5"}
                                                </span>

                                                <span className="
                                                    text-slate-400
                                                    text-xs
                                                ">
                                                    Excellent
                                                </span>

                                            </div>

                                        </div>


                                        {/* ================= PRICE ================= */}

                                        <div className="
                                            absolute
                                            bottom-4
                                            right-4
                                            z-20
                                            bg-gradient-to-r
                                            from-[#002B45]
                                            via-[#174B5F]
                                            to-[#D4A83F]
                                            text-white
                                            px-4
                                            py-2
                                            rounded-2xl
                                            shadow-xl
                                        ">

                                            <p className="
                                                text-[9px]
                                                uppercase
                                                tracking-wider
                                                opacity-80
                                            ">
                                                From
                                            </p>

                                            <p className="
                                                text-sm
                                                font-bold
                                            ">
                                                AED{" "}
                                                {Math.round(
                                                    hotel.price_per_night
                                                )}

                                                <span className="
                                                    text-[10px]
                                                    font-normal
                                                    opacity-80
                                                ">
                                                    {" "} / night
                                                </span>
                                            </p>

                                        </div>

                                    </div>


                                    {/* ================= CONTENT ================= */}

                                    <div className="p-5 sm:p-6">

                                        {/* Hotel Name */}

                                        <h3
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                navigate(
                                                    `/hotels/${hotel.slug}`
                                                );
                                            }}
                                            className="
                                                text-lg
                                                sm:text-xl
                                                font-bold
                                                text-slate-900
                                                line-clamp-1
                                                group-hover:text-[#174B5F]
                                                transition-colors
                                                duration-300
                                            "
                                        >
                                            {hotel.name}
                                        </h3>


                                        {/* Location */}

                                        <div className="
                                            flex
                                            items-center
                                            gap-2
                                            mt-2
                                            text-slate-500
                                        ">

                                            <FaMapMarkerAlt className="text-[#D4A83F] text-sm" />

                                            <span className="text-sm line-clamp-1">
                                                {hotel.location ||
                                                    "Dubai, UAE"}
                                            </span>

                                        </div>


                                        {/* Divider */}

                                        <div className="
                                            h-px
                                            bg-slate-100
                                            my-4
                                        "></div>


                                        {/* Description */}

                                        <p className="
                                            text-slate-600
                                            text-sm
                                            leading-6
                                            line-clamp-2
                                            min-h-[48px]
                                        ">
                                            {hotel.short_description?.replace(
                                                /<[^>]*>/g,
                                                ""
                                            )}
                                        </p>


                                        {/* Amenities */}

                                        <div className="
                                            flex
                                            flex-wrap
                                            gap-2
                                            mt-4
                                        ">

                                            <span className="
                                                px-2.5
                                                py-1
                                                rounded-full
                                                bg-[#F8F5EC]
                                                text-[#174B5F]
                                                text-[11px]
                                                font-medium
                                            ">
                                                🏊 Pool
                                            </span>

                                            <span className="
                                                px-2.5
                                                py-1
                                                rounded-full
                                                bg-[#F8F5EC]
                                                text-[#174B5F]
                                                text-[11px]
                                                font-medium
                                            ">
                                                📶 WiFi
                                            </span>

                                            <span className="
                                                px-2.5
                                                py-1
                                                rounded-full
                                                bg-[#F8F5EC]
                                                text-[#174B5F]
                                                text-[11px]
                                                font-medium
                                            ">
                                                🍽 Restaurant
                                            </span>

                                        </div>


                                        {/* ================= BUTTON ================= */}

                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();

                                                navigate(
                                                    `/hotels/${hotel.slug}`
                                                );
                                            }}
                                            className="
                                                mt-5
                                                w-full
                                                py-3
                                                rounded-xl
                                                bg-gradient-to-r
                                                from-[#002B45]
                                                via-[#174B5F]
                                                to-[#D4A83F]
                                                text-white
                                                text-sm
                                                font-semibold
                                                shadow-md
                                                hover:shadow-xl
                                                hover:-translate-y-0.5
                                                transition-all
                                                duration-300
                                            "
                                        >
                                            View Hotel Details
                                            <span className="ml-2">
                                                →
                                            </span>
                                        </button>

                                    </div>

                                </div>

                            ))}

                        </div>


                    ) : (

                        /* ================= EMPTY STATE ================= */

                        <div className="
                            bg-white
                            rounded-[28px]
                            border border-slate-100
                            shadow-sm
                            py-20
                            px-6
                            text-center
                        ">

                            <div className="
                                w-16
                                h-16
                                mx-auto
                                rounded-2xl
                                bg-[#F8F5EC]
                                flex
                                items-center
                                justify-center
                                mb-5
                            ">
                                <FaMapMarkerAlt className="
                                    text-2xl
                                    text-[#D4A83F]
                                " />
                            </div>

                            <h3 className="
                                text-xl
                                font-bold
                                text-slate-900
                            ">
                                No Hotels Found
                            </h3>

                            <p className="
                                text-slate-500
                                text-sm
                                mt-2
                                max-w-md
                                mx-auto
                            ">
                                We couldn't find any hotels matching
                                your search. Try another destination
                                or explore all available hotels.
                            </p>

                            <button
                                onClick={() =>
                                    navigate("/hotels")
                                }
                                className="
                                    mt-6
                                    px-7
                                    py-3
                                    rounded-xl
                                    bg-gradient-to-r
                                    from-[#002B45]
                                    via-[#174B5F]
                                    to-[#D4A83F]
                                    text-white
                                    text-sm
                                    font-semibold
                                    shadow-md
                                    hover:shadow-xl
                                    hover:-translate-y-0.5
                                    transition-all
                                "
                            >
                                Explore All Hotels →
                            </button>

                        </div>

                    )}

                </div>

            </section>

        </div>
    );
}